const RenderTest = require("./containers/RenderTest");
const Authenticate = require("../utils").authenticate;

module.exports = {
    path: "/render-test",
    component: Authenticate(RenderTest),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/render-test/index.js